<template>
  <CategoriesMenuMobile />
</template>

<script setup>
import CategoriesMenuMobile from '~/components/categories_menu_mobile/index.vue'

const { $tracking } = useNuxtApp()

definePageMeta({
  layout: 'categories',
})
useHead(() => {
  return {
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
              'Исследуйте все категории товаров для аренды на Polka. От туристического снаряжения до детских товаров — у нас есть всё, что вам нужно. Удобная навигация и широкий выбор для любых целей.',
      },
    ],
  }
})
onMounted(() => {
  $tracking.logEventAmplitude('view catalog MOBILE')
})
</script>
